/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for LicenceServer controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { UpdateLicenceServerRequest, RequestOptions, LicenceServerProduct, GetLicenceServersByCustomerIdResponse, CreateLicenceServerRequest, CreateLicenceServerResponse, GenerateCredentialResponse } from "../models";

@Injectable({ providedIn: "root" })
export class LicenceServerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    updateLicenceServer(id: number, updateLicenceServerRequest: UpdateLicenceServerRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateLicenceServer(id: number, updateLicenceServerRequest: UpdateLicenceServerRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateLicenceServer(id: number, updateLicenceServerRequest: UpdateLicenceServerRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateLicenceServer(id: number, updateLicenceServerRequest: UpdateLicenceServerRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicenceServer/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateLicenceServerRequest, requestOptions);
    }

    deleteLicenceServer(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteLicenceServer(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteLicenceServer(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteLicenceServer(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicenceServer/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getOwnLicenceServerProducts(observe?: 'body', options?: RequestOptions<'json'>): Observable<LicenceServerProduct>;
    getOwnLicenceServerProducts(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<LicenceServerProduct>>;
    getOwnLicenceServerProducts(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<LicenceServerProduct>>;
    /** The licence server is resolved from the authenticated machine token; no route parameters are needed. */
    getOwnLicenceServerProducts(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicenceServer/M2M/Products`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getLicenceServersByCustomerId(customerId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetLicenceServersByCustomerIdResponse>;
    getLicenceServersByCustomerId(customerId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetLicenceServersByCustomerIdResponse>>;
    getLicenceServersByCustomerId(customerId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetLicenceServersByCustomerIdResponse>>;
    getLicenceServersByCustomerId(customerId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicenceServer`;

        let params = new HttpParams();
        if (customerId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, customerId, 'customerId');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createLicenceServer(createLicenceServerRequest: CreateLicenceServerRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateLicenceServerResponse>;
    createLicenceServer(createLicenceServerRequest: CreateLicenceServerRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateLicenceServerResponse>>;
    createLicenceServer(createLicenceServerRequest: CreateLicenceServerRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateLicenceServerResponse>>;
    createLicenceServer(createLicenceServerRequest: CreateLicenceServerRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicenceServer`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createLicenceServerRequest, requestOptions);
    }

    getLicenceServerProducts(clientGuid: string, serverReference: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<LicenceServerProduct>;
    getLicenceServerProducts(clientGuid: string, serverReference: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<LicenceServerProduct>>;
    getLicenceServerProducts(clientGuid: string, serverReference: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<LicenceServerProduct>>;
    getLicenceServerProducts(clientGuid: string, serverReference: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicenceServer/${clientGuid}/${serverReference}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    generateLicenceServerCredential(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GenerateCredentialResponse>;
    generateLicenceServerCredential(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GenerateCredentialResponse>>;
    generateLicenceServerCredential(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GenerateCredentialResponse>>;
    /** Returns the client id and secret once. The secret is not stored and cannot be retrieved later. */
    generateLicenceServerCredential(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicenceServer/${id}/Credentials`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, null, requestOptions);
    }
}
